import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/shared/contexts/AuthContext';
import { APP_STRINGS } from '@/shared/constants';
import { getRoleBasedRedirect } from '@/shared/lib/auth.utils';

interface PublicRouteProps {
  children: ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { user, isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return (
      <output
        className="min-h-screen flex items-center justify-center"
        aria-live="polite"
      >
        <div className="text-center">
          <div
            className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"
            aria-hidden="true"
          ></div>
          <p className="mt-4 text-muted-foreground">{APP_STRINGS.LOADING}</p>
        </div>
      </output>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={getRoleBasedRedirect(user?.roles ?? [])} replace />;
  }

  return <>{children}</>;
};
